import { AnchorHTMLAttributes, DetailedHTMLProps } from 'react';
import classNames from 'classnames';
import { BiLinkExternal } from '@react-icons/all-files/bi/BiLinkExternal';
import { Testable } from './types';

type ExternalLinkProps = DetailedHTMLProps<
  AnchorHTMLAttributes<HTMLAnchorElement>,
  HTMLAnchorElement
>;

export function ExternalLink(props: Testable<ExternalLinkProps>) {
  return (
    <a
      {...props}
      className={classNames(
        'group text-gray-600 hover:text-blue transition-all hover:border-blue border-gray-400',
        props.className,
      )}
      target="_blank"
    >
      <BiLinkExternal className="mr-1 mb-0.5 text-gray-400 group-hover:text-blue inline-block transition-all" />
      {props.children}
    </a>
  );
}
